// Generated by scripts/build-ui-icons.mjs.
export { MapTrifold as default } from "../ui/glyphs-5";
